import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  inject
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Contract } from 'src/app/classes/models';
import { ContractService } from 'src/app/services/contract.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-contract-review',
  templateUrl: './contract-review.component.html',
  styleUrls: ['./contract-review.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContractReviewComponent implements OnDestroy {
  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private route: ActivatedRoute,
    private ToastService: ToastService,
    private SharedDataService: SharedDataService,
    private ContractService: ContractService
  ) {
    const params = this.route.snapshot.paramMap;
    const ContractId = Number(params.get('ContractId')) || null;

    if (!ContractId) {
      throw this.ToastService.addErrorToast(
        'Error',
        'No Contract ID. Cannot get details.'
      );
    }

    this.SharedDataServiceSubscription =
      this.SharedDataService.listenForEvent().subscribe({
        next: ({ eventName }) => {
          if (eventName === 'isFormValid') {
            this.SharedDataService.sendEvent('formIsValid');
          }
          this._cdr.markForCheck();
        }
      });

    this.SharedDataService.sendEvent(
      'UpdateContract',
      new Contract({ id: ContractId })
    );
    this._cdr.markForCheck();
  }

  ContractId!: number;
  SharedDataServiceSubscription: Subscription;

  ngOnDestroy(): void {
    this.SharedDataServiceSubscription.unsubscribe();
  }
}
